import { HeadingPages } from '../../../components/HeadingPages'
import { QueryErrorResetBoundary, useMutation } from 'react-query'
import { ErrorBoundary } from 'react-error-boundary'
import { Layout } from '../../../components/Layout'
import {
  Button,
  Flex,
  Table,
  TableContainer,
  Tbody,
  Th,
  Thead,
  Tr,
  useToast,
} from '@chakra-ui/react'
import { List } from './List'
import InputFloating from '../../../components/InputFloating'
import { api } from '../../../services/api'
import { useForm } from 'react-hook-form'
import { Loader } from '../../../components/ComponentLoader/Loader'
import { z } from 'zod'
import { zodResolver } from '@hookform/resolvers/zod'
import { useEffect } from 'react'
import { format } from 'date-fns'

const schema = z.object({
  dataInicial: z.string(),
  dataFinal: z.string(),
})

async function getHistoryData({ dataSaida, dataEntrada }) {
  const response = await api.get(
    `/site/v2/crm-controle/listar-chamados-sistema?concluido=S&data_saida=${dataSaida}&data_entrada=${dataEntrada}`
  )

  if (!dataSaida && !dataEntrada) {
    return response.data
    .sort((a, b) => {
      return new Date(b.data_abertura) - new Date(a.data_abertura)
    })
    .map(item => {
      return {
        ...item,
        data_abertura: item.data_abertura ? format(new Date(item.data_abertura), 'dd/MM/yyyy HH:mm') : '',
        description: item?.detalhes_problema?.substring(0, 15).concat('...'),
      }
    }).slice(0, 30)
  }

  return response.data
  .sort((a, b) => {
    return new Date(b.data_abertura) - new Date(a.data_abertura)
  }
  )
  .map(item => {
    return {
      ...item,
      data_abertura: item.data_abertura ? format(new Date(item.data_abertura), 'dd/MM/yyyy') : '',
      description: item?.detalhes_problema?.substring(0, 15).concat('...'),
    }
  })
}

export function HistoricoChamados() {
  const { handleSubmit, register } = useForm({
    resolver: zodResolver(schema),
  })

  const toast = useToast({
    position: 'top',
    duration: 5000,
    isClosable: true,
  })

  const { data, mutateAsync, isLoading } = useMutation({
    mutationFn: getHistoryData,
    onError: () => {
      toast({
        title: 'Erro ao buscar informações de retificação de layout',
        status: 'error',
      })
    },
  })

  async function handleSearch(data) {
    console.log(data)
    try {
      await mutateAsync({
        concluido: data.status,
        dataSaida: data.dataFinal,
        dataEntrada: data.dataInicial,
      })
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    async function fetchData() {
      try {
        handleSearch({
          dataInicial: '',
          dataFinal: '',
          status: 'S',
        })
      } catch (error) {
        console.log(error)
      }
    }

    fetchData()
  }, [])

  console.log(data)

  return (
    <>
      <HeadingPages name="Histórico de Chamados" />

      <Layout>
        <Flex
          gap={2}
          mb={2}
          as="form"
          onSubmit={handleSubmit(handleSearch)}
          maxW="900px"
          w="full"
          mx={'auto'}
        >
          <InputFloating
            type="date"
            label="Data inicial"
            {...register('dataInicial')}
          />
          <InputFloating
            type="date"
            label="Data final"
            {...register('dataFinal')}
          />
          <Button
            colorScheme="blue"
            w="full"
            maxW="150px"
            isLoading={isLoading}
            type="submit"
          >
            Buscar
          </Button>
        </Flex>

        <QueryErrorResetBoundary>
          {({ reset }) => (
            <ErrorBoundary
              onReset={reset}
              fallbackRender={({ resetErrorBoundary }) => (
                <div>
                  Erro ao buscar informações de retificação de layout
                  <button onClick={() => resetErrorBoundary()}>
                    Tentar novamente
                  </button>
                </div>
              )}
            >
              {!isLoading && data?.length === 0 && (
                <Flex justify="center" align="center" h="full">
                  Nenhum registro encontrado
                </Flex>
              )}

              {!isLoading && data?.length > 0 && (
                <TableContainer>
                  <Table>
                    <Thead>
                      <Tr bg="blue.500">
                        <Th color="gray.50">Solicitado por</Th>
                        <Th color="gray.50">Data de abertura</Th>
                        <Th color="gray.50" textAlign={'center'}>
                          Tipo de chamado
                        </Th>
                        <Th color="gray.50" textAlign={'center'}>
                          Descrição
                        </Th>
                        <Th color="gray.50">Imagem</Th>
                        {/* <Th color="gray.50" textAlign={"center"}>
                          Data finalizado
                        </Th> */}
                        <Th color="gray.50" textAlign={'center'}>
                          Responsável pelo chamado
                        </Th>
                        <Th color="gray.50" textAlign={'center'}>
                          Solução
                        </Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {data?.map((item, index) => (
                        <List key={index} item={item} />
                      ))}
                    </Tbody>
                  </Table>
                </TableContainer>
              )}

              {isLoading && <Loader />}
            </ErrorBoundary>
          )}
        </QueryErrorResetBoundary>
      </Layout>
    </>
  )
}
